import React, { useEffect, useState } from "react";
import { config } from "../config/config";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit, faTrashAlt } from "@fortawesome/free-solid-svg-icons";

const ResultadoActividadList = ({ onEdit, onDelete, reloadTrigger }) => {
    const [resultados, setResultados] = useState([]);

    // Función para obtener los resultados desde la API
    const fetchResultados = () => {
        fetch(`${config.apiUrl}/resultadosActividades`)
            .then((res) => res.json())
            .then(setResultados)
            .catch(console.error);
    };

    // Efecto para cargar los resultados al inicio y cuando cambie reloadTrigger
    useEffect(() => {
        fetchResultados();
    }, [reloadTrigger]);

    return (
        <div className="container mt-5">
            <h2 className="mb-4">Lista de Resultados de Actividades</h2>
            <table className="table table-bordered table-striped table-dark">
                <thead className="thead-dark">
                <tr>
                    <th>ID Actividad</th>
                    <th>Actividad</th>
                    <th>Alumno</th>
                    <th>Calificación</th>
                    <th colSpan={2} className="text-center">Acciones</th>
                </tr>
                </thead>
                <tbody>
                {resultados.map((resultado) => (
                    <tr key={resultado.resultado_id}>
                        <td>{resultado.actividad_id}</td>
                            <td>{resultado.nombre_actividad}</td>
                        <td>{resultado.nombre}</td>
                        <td>{resultado.calificacion}</td>
                        <td className="text-center">
                            <button
                                className="btn btn-warning btn-sm mr-2"
                                onClick={() => onEdit(resultado)}
                            >
                                <FontAwesomeIcon icon={faEdit} />
                            </button>
                        </td>
                        <td className="text-center">
                            <button
                                className="btn btn-danger btn-sm"
                                onClick={() => onDelete(resultado.resultado_id)}
                            >
                                <FontAwesomeIcon icon={faTrashAlt} />
                            </button>
                        </td>
                    </tr>
                ))}
                </tbody>
            </table>
        </div>
    );
};

export default ResultadoActividadList;